import React from 'react';

import Logo from '@liquidweb-dev/undercurrent/logos/ThemeAwareLogo';
import { useTheme } from '@liquidweb-dev/undercurrent/styles';

export const logoSxByBrand = {
	nexcess: { width: '110px', height: 'auto' },
	liquidweb: { width: '152px', height: 'auto' },
};

export function BrandLogo({ sx = {} }) {
	const { name: brand = 'liquidweb' } = useTheme();
	const brandLogoSx = logoSxByBrand[brand] ?? logoSxByBrand.liquidweb;

	return <Logo sx={{ ...brandLogoSx, ...sx }} />;
}

export default BrandLogo;
